import { Component } from '@angular/core';
import { CarLinerProductTableComponent } from '../car-liner-product-table/car-liner-product-table.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'car-liner-included-items-table',
    templateUrl: './car-liner-included-items-table.component.html',
    styleUrl: './car-liner-included-items-table.component.scss',
    standalone: false
})
export class CarLinerIncludedItemsTableComponent extends CarLinerProductTableComponent {
  public isJosam: boolean = environment.projectName === 'josam';
}
